import { render } from "./AutoScaleDownPolicyTab.vue?vue&type=template&id=41736ce9&scoped=true"
import script from "./AutoScaleDownPolicyTab.vue?vue&type=script&lang=js"
export * from "./AutoScaleDownPolicyTab.vue?vue&type=script&lang=js"

import "./AutoScaleDownPolicyTab.vue?vue&type=style&index=0&id=41736ce9&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41736ce9"]])

export default __exports__